export default "__VITE_ASSET__CQfKkwn9__"